export const SnackBarType = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const ModalType = {
  ALERT_MODAL: 'ALERT_MODAL',
  DIALOG_TEXT: 'DIALOG_TEXT',
  AWARD_MODAL: 'AWARD_MODAL',
  UPLOAD_DIALOG: 'UPLOAD_DIALOG',
};

export const NodeType = {
  TRIGGER: 'trigger',
  MESSAGE: 'message',
  START: 'start',
  END: 'end',
  CONDITION: 'condition',
  MA: 'ma',
  GROUP: 'group',
  TAGGING: 'tagging',
  GACONDITION: 'GA_condition',
  INBOX: 'inbox',
  COUPON: 'coupon',
  CUSTOMERCONDITION: 'customer_condition',
  SCHEDULE: 'schedule',
  WAIT: 'wait',
};

export const EdgeType = {
  ADD: 'add',
  SMOOTHSTEP: 'smoothstep',
};

export const TabType = {
  SETTING: 'setting',
  RULE: 'rule',
};

export const FacebookTagType = {
  NO_TAG: 'NO_TAG',
  HUMAN_AGENT: 'HUMAN_AGENT',
  CONFIRMED_EVENT_UPDATE: 'CONFIRMED_EVENT_UPDATE',
  POST_PURCHASE_UPDATE: 'POST_PURCHASE_UPDATE',
  ACCOUNT_UPDATE: 'ACCOUNT_UPDATE',
};

export const PlatformType = {
  FACEBOOK: 'facebook',
  LINE: 'line',
  INSTAGRAM: 'instagram',
  WHATSAPP: 'whatsapp',
  LIVECHAT: 'livechat',
};

export const TriggerType = {
  ADD: 'join',
  UNBLOCK: 'rejoin',
  TAG: 'tag',
  KEYWORD: 'keyword',
  OTHER: 'other',
  GA: 'ga',
  BIRTHDAY: 'birthday',
  CUSTOM_FIELD_DATE: 'customFieldDate',
};

export const GATriggerType = {
  GAVIEW: 'GA_pageView',
  GAREMOVEFROMCART: 'GA_removeFromCart',
  GAADDTOCART: 'GA_addToCart',
  GAPURCHASE: 'GA_purchase',
};

export const CustomerConditionType = {
  TAG: 'tag',
  BIRTHDAY: 'birthday',
  GENDER: 'gender',
  LOCATION: 'location',
};

export const TriggerFlowModeType = {
  BOT: 'bot',
  SUPERLINK: 'superlink',
  PROCEDURE: 'ma',
  API: 'api',
};

export const TagFilterType = {
  INCLUDE: 'include',
  EXCLUDE: 'exclude',
};

export const KeyWordFilterType = {
  KEYWORD: 'keyword', // 關鍵字等於
  IN: 'in', // 文字中包含
  NIN: 'nin', // 文字中不包含
  EQ: 'eq', // 數字等於
  NE: 'ne', // 數字不等於
  LT: 'lt', // 數字小於
  LTE: 'lte', // 數字小於等於
  GT: 'gt', // 數字大於
  GTE: 'gte', // 數字大於等於
  STARTSWITH: 'startsWith', // 文字開頭是
  ENDSWITH: 'endsWith', // 文字結尾是
};

export const ImagemapTemplateType = {
  ImagemapTemplate1: [
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '0%',
      width: '100%',
      height: '100%',
    },
  ],
  ImagemapTemplate2: [
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '0%',
      width: '100%',
      height: '50%',
    },
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '50%',
      width: '100%',
      height: '50%',
    },
  ],
  ImagemapTemplate3: [
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '0%',
      width: '100%',
      height: '50%',
    },
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '50%',
      width: '50%',
      height: '50%',
    },
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '50%',
      y: '50%',
      width: '50%',
      height: '50%',
    },
  ],
  ImagemapTemplate4: [
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '0%',
      width: '50%',
      height: '50%',
    },
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '50%',
      y: '0%',
      width: '50%',
      height: '50%',
    },
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '50%',
      width: '50%',
      height: '50%',
    },
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '50%',
      y: '50%',
      width: '50%',
      height: '50%',
    },
  ],
  ImagemapTemplate5: [
    {
      title: '',
      type: 'postback',
      data: '',
      tags: [],
      x: '0%',
      y: '0%',
      width: '50%',
      height: '50%',
    },
  ],
};

export const MAStatusType = {
  SCHEDULED: 'scheduled',
  PROGRESS: 'progress',
  PAUSING: 'pausing',
  TERMINATED: 'terminated',
  DONE: 'done',
  EDIT: 'editing',
  ERROR: 'error',
};

export const ConditionsType = {
  CLICK: 'click',
  STICKER: 'sticker',
  KEYWORD: 'keyword',
};

export const ConditionsClickType = {
  BUTTON: 'button',
  ANY: 'any',
};

export const ConditionsKeywordType = {
  ANY: 'any',
  KEYWORD: 'keyword',
};

export const TriggerTimeType = {
  MINUTE: 'minute',
  DAY: 'day',
  HOUR: 'hour',
};

// 行為設置 - 行為形式
export const MANodeType = {
  MA: 'ma',
};

export const VendorStore = {
  MA_VENDOR_ID: 'marketing_automation',
};

export const UrlFilterType = {
  EQ: 'eq', // 網址是
  IN: 'in', // 網址包含
  NIN: 'nin', // 網址不包含
};

export const NextResourceName = {
  MSG_TEMPLATE_LIMIT: 'msg_template_limit',
  WEBVIEW_EDITOR_LIMIT: 'webview_editor_limit',
};

export const BirthdayType = {
  DAY: 'day',
  MONTH: 'month',
  NEXT_MONTH: 'nextMonth',
};

export const GenderType = {
  MALE: 'male',
  FEMALE: 'female',
  CUSTOM: 'custom',
};

export const ProviderType = {
  SHOPLINE: 'shopline',
  SHOPIFY: 'shopify',
  CYBERBIZ: 'cyberbiz',
  SALESFORCE: 'salesforce',
};

export const ProviderActionType = {
  TOTALORDERCOUNT: 'totalOrderCount',
  TOTALORDERAMOUNT: 'totalOrderAmount',
  SINGLEORDERAMOUNT: 'singleOrderAmount',
  BINDEC: 'bindEc',
  MEMBERSHIPTIER: 'membershipTier',
  USERCREDIT: 'userCredit',
  MEMBERPOINT: 'memberPoint',
};

export const ScheduleType = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
};
